import React from 'react'

import {
  ProviderInsightsCompetencyAreaLabels,
  ProviderInsightsCompetencyCategory,
} from '@lyrahealth-inc/shared-app-logic/src/features/careInsights/constants'
import {
  CareInsightsSubsection,
  CareInsightsSubsectionProps,
} from '@lyrahealth-inc/ui-core-crossplatform/src/organisms/careInsightsSubsection/CareInsightsSubsection'

type RiskManagementInsightsProps = Partial<CareInsightsSubsectionProps>

export const RiskManagementInsights: React.FC<RiskManagementInsightsProps> = ({
  aiInsightsCurrentMonth,
  aiInsightsPastMonth,
  getClientInfoFromIds,
  isLoadingClients,
  isLoadingProviderInsights,
  isSupervisor,
  onClientPress,
  onSupervisorUsageGuidelinesPress,
}) => {
  const competencyAreaName = ProviderInsightsCompetencyCategory.RISK_MANAGEMENT

  return (
    <CareInsightsSubsection
      title={ProviderInsightsCompetencyAreaLabels[competencyAreaName]}
      competencyAreaName={competencyAreaName}
      testIDPrefix='RiskManagementInsights'
      aiInsightsCurrentMonth={aiInsightsCurrentMonth}
      aiInsightsPastMonth={aiInsightsPastMonth}
      getClientInfoFromIds={getClientInfoFromIds}
      isLoadingClients={isLoadingClients}
      isLoadingProviderInsights={isLoadingProviderInsights}
      isSupervisor={isSupervisor}
      onClientPress={onClientPress}
      onSupervisorUsageGuidelinesPress={onSupervisorUsageGuidelinesPress}
    />
  )
}
